import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-temporaryredelegation',
  imports: [RouterOutlet],
  templateUrl: './temporaryredelegation.component.html',
  styleUrl: './temporaryredelegation.component.css',
})
export class TemporaryredelegationComponent { }
